import { render, staticRenderFns } from "./disusePK.vue?vue&type=template&id=73032109&scoped=true&"
import script from "./disusePK.vue?vue&type=script&lang=js&"
export * from "./disusePK.vue?vue&type=script&lang=js&"
import style0 from "./disusePK.vue?vue&type=style&index=0&id=73032109&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73032109",
  null
  
)

export default component.exports